import { render, staticRenderFns } from "./SidebarLayout.vue?vue&type=template&id=0a29a003&scoped=true"
import script from "./SidebarLayout.vue?vue&type=script&lang=js"
export * from "./SidebarLayout.vue?vue&type=script&lang=js"
import style0 from "./SidebarLayout.vue?vue&type=style&index=0&id=0a29a003&prod&lang=scss&scoped=true"
import style1 from "./SidebarLayout.vue?vue&type=style&index=1&id=0a29a003&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a29a003",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VAppBarNavIcon } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VMain } from 'vuetify/lib/components/VMain';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VApp,VAppBar,VAppBarNavIcon,VBtn,VCard,VCardTitle,VContainer,VDialog,VMain,VNavigationDrawer})
